import scroll from "./animations/scroll/locomotiveScroll";

export default () => {
  let policyLinksLinks = document.getElementsByClassName("policy-link");
  for (let i = 0; i < policyLinksLinks.length; i++) {
    let el = policyLinksLinks[i];
    el.addEventListener(
      "click",
      () => {
        let target = document.querySelector(el.getAttribute("href"));
        scroll.scrollTo({ target });
      },
      false
    );
  }
};
